var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in","appear":""}},[_c('router-view',{attrs:{"data_fetched":_vm.data_fetched}})],1),_vm._v(" "),_c("BackToTopButton",{tag:"div"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }